import { Injectable } from "@angular/core";
import { BaseFpxComponentState } from "@common/utils";
import {
  AbstractControl,
  FormControlStatus,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from "@angular/forms";
import {
  BaseFpxChangeHandler,
  BaseFpxFormHelper,
  CriteriaQuery,
} from "@fpx/core";
import { DepositService } from "../services/deposits.service";
import { DepositsInfo } from "../models/deposits-info.model";
import { ProcessShellService } from "src/app/process-shell/services/process-shell.service";
import { REFERENCE_KEY } from "@common/constants";
import { AccountsService } from "src/app/services/accounts/accounts.service";
import { DepositDetailService } from "./deposit-detail-form.service";
import { CommonService } from "src/app/common.service";
import { FileOpenerService } from "src/app/services/mobile/file-opener.service";

export class DepositDetailState implements BaseFpxComponentState {
  depositsInfo: DepositsInfo;
  nickname?: string;
  
}

@Injectable()
export class DepositDetailHelper extends BaseFpxFormHelper<DepositDetailState> {
  resultDetails;
  httpProvider: any;
  status: String = "";

  constructor(
    private _depositDetailService: DepositDetailService,
    private _depositsService: DepositService,
    private processService: ProcessShellService,
    private _accountService: AccountsService,
    private _commonService: CommonService,
    private _fileOpner: FileOpenerService
  ) {
    super(new DepositDetailState());
  }
  override doPreInit(): void {
    this.addChangeHandler("accountNumber", this.doAccountNumberChange);
    let cardRefNum = this.getRoutingParam(REFERENCE_KEY);

    this.formGroup.controls["accountNumber"].patchValue(cardRefNum, {
      emitEvent: false,
    });
    console.log("FormGroupValueIs:", this.formGroup.value);

  }
  override doPostInit(): void {
  }
  private doAccountNumberChange: BaseFpxChangeHandler = (
    name: string,
    status: FormControlStatus,
    value: any,
    formGroup: FormGroup
  ) => {
    const accountNum = value;
    var data = this._accountService.nicknames;
    let filterNickData = data?.find(x => x.accountNumber == accountNum)

    this.state.nickname = filterNickData.nickName;

    console.log("Welcome-user-nickname", this.state.nickname);
  };

  public doConfirm(context: any, success: any, failure: any) { }

  public doSubmit(context: any, success: any, failure: any) {
    //
  }

  downloadGICReceipt(accountNumber: string) {
    let cardRefNum: any;
    cardRefNum = accountNumber;
    this._depositDetailService.downloadGICReceipt(cardRefNum).subscribe({
      next: (response: any) => {
        this._commonService.hideSpinner();
        if (this._commonService.isHybrid()) {
          this._fileOpner.openPDF(
            response,
            "application/pdf",
            "Deposit receipt.pdf"
          );
        } else {
          let documentURL = URL.createObjectURL(
            new Blob([response.body], { type: "application/pdf" })
          );
          const downloadLink = document.createElement("a");
          downloadLink.href = documentURL;
          const fileName = "Deposit receipt";
          downloadLink.download = fileName;
          downloadLink.click();
        }
      },
    });
  }
}
